<template>
  <div class="h-100">
    <div class="match-card match-card__try-again text-center" v-if="show">
      <div class="match-card__desc">
        <div class="title">
          {{ trans.get('pages:match_game.free_matchgames_over_card.header') }}
        </div>

        <div class="desc my-1">

          {{ trans.get('pages:match_game.free_matchgames_over_card.slogan') }}
        </div>
      </div>

      <div class="match-card__image">
        <img src="../../../images/match-game/play-again.png" alt="Play again Icon">
      </div>

      <div class="match-card__coins">
        <div class="title">{{ tryAgainValue }}<i class="demo-icon icon-coins"></i></div>
      </div>

      <div v-if="false" class="match-card__approval">
        <div class="checkbox-standard">
          <label>
            <input type="checkbox" v-model="paymentApproval">
            <span class="checkbox-standard__box checkbox-standard__box--small checkbox-standard__box--purple mr-2"></span>

            <span class="desc"> {{ trans.get('pages:match_game.free_matchgames_over_card.confirm_label') }}</span>
          </label>
        </div>
      </div>

      <div class="match-card__button">
        <button class="button button--primary" @click="buyAction()">{{ trans.get('pages:match_game.free_matchgames_over_card.try_again_button') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'NoMoreMatchesCard',
  props: {
    current: Object,
  },
  data() {
    return {
      paymentApproval: false,
      tryAgainValue: null,
      show: false,
    };
  },
  computed: {
    ...mapGetters('user', {
      user: 'getUser',
      isPaymentApproved: 'isPaymentApproved',
    }),
    avatars: function () {
      return this.$store.getters['homeProfiles/getRandomAvatars'];
    }
  },
  methods: {
    buyAction() {
      axios.post(zRoute('ajax.match_game.match_try_again'), {
        agreement: this.paymentApproval,
      }).then(response => {
        this.$emit('load');
      }).catch(error => {
        const data = error.response.data;
        if (data.status === 'error') {
          this.$emit('errorReason', data.reason);
        }
      });
    },
  },
  mounted() {
    this.tryAgainValue = window.globals.settings_payment_match_game;

    if (this.isPaymentApproved(window.globals.user.payment_approval_match_game)) {
      this.buyAction();
    } else {
      this.show = true;
    }
  }
};
</script>


